































import { defineComponent, PropType } from '@vue/composition-api'

// models
import { PropOptionSelect } from '@/models'

export default defineComponent({
  name: 'Select',
  props: {
    options: {
      type: Array as PropType<PropOptionSelect[]|number[]|string[]>,
      required: true
    },
    label: {
      type: String as PropType<string>,
      default: ''
    },
    size: {
      type: String as PropType<string>,
      default: 'md'
    },
    required: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    disabled: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    placeholder: {
      type: String as PropType<string>,
      default: 'Seleccione una Opción'
    },
    id: {
      type: String as PropType<string>,
      default: ''
    },
    name: {
      type: String as PropType<string>,
      default: ''
    },
    className: {
      type: String as PropType<string>,
      default: ''
    },
    iconClass: {
      type: String as PropType<string>,
      default: ''
    },
    value: {
      type: [String, Number] as PropType<string|number>,
      default: ''
    },
    msgError: {
      type: String as PropType<string>,
      default: ''
    },
    hasError: {
      type: Boolean as PropType<boolean>,
      default: false
    }
  }
})
